import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MathQuiz.css';

const MathQuiz = () => {
  const [question, setQuestion] = useState({});
  const [userAnswer, setUserAnswer] = useState('');
  const [score, setScore] = useState(0);
  const [questionsAnswered, setQuestionsAnswered] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [timeLeft, setTimeLeft] = useState(60);
  const [gameActive, setGameActive] = useState(false);
  const [gameOver, setGameOver] = useState(false);

  const operations = ['+', '-', '*'];

  const generateQuestion = () => {
    const operation = operations[Math.floor(Math.random() * operations.length)];
    let num1, num2, answer;

    switch (operation) {
      case '+':
        num1 = Math.floor(Math.random() * 50) + 1;
        num2 = Math.floor(Math.random() * 50) + 1;
        answer = num1 + num2;
        break;
      case '-':
        num1 = Math.floor(Math.random() * 50) + 25;
        num2 = Math.floor(Math.random() * 25) + 1;
        answer = num1 - num2;
        break;
      case '*':
        num1 = Math.floor(Math.random() * 12) + 1;
        num2 = Math.floor(Math.random() * 12) + 1;
        answer = num1 * num2;
        break;
      default:
        num1 = 1;
        num2 = 1;
        answer = 2;
    }

    return { num1, num2, operation, answer };
  };

  const startGame = () => {
    setGameActive(true);
    setGameOver(false);
    setScore(0);
    setQuestionsAnswered(0);
    setTimeLeft(60);
    setFeedback('');
    setQuestion(generateQuestion());
  };

  const submitAnswer = () => {
    const answer = parseInt(userAnswer);
    const newQuestionsAnswered = questionsAnswered + 1;
    
    setQuestionsAnswered(newQuestionsAnswered);
    
    if (answer === question.answer) {
      setScore(prev => prev + 1);
      setFeedback('✅ Correct!');
    } else {
      setFeedback(`❌ Wrong! The answer was ${question.answer}`);
    }
    
    setUserAnswer('');
    
    setTimeout(() => {
      if (timeLeft > 0) {
        setQuestion(generateQuestion());
        setFeedback('');
      }
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && gameActive && !gameOver) {
      submitAnswer();
    }
  };

  useEffect(() => {
    let timer;
    if (gameActive && timeLeft > 0) {
      timer = setTimeout(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    } else if (timeLeft === 0 && gameActive) {
      setGameActive(false);
      setGameOver(true);
    }
    
    return () => clearTimeout(timer);
  }, [timeLeft, gameActive]);

  const accuracy = questionsAnswered > 0 ? Math.round((score / questionsAnswered) * 100) : 0;

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🧮 Math Quiz</h1>
        <div className="game-instructions">
          Solve as many math problems as you can in 60 seconds!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Score: {score}/{questionsAnswered} | Time: {timeLeft}s
          {questionsAnswered > 0 && ` | Accuracy: ${accuracy}%`}
        </div>
        
        {!gameActive && !gameOver && (
          <div className="start-screen">
            <p>Ready to test your math skills?</p>
            <button className="btn btn-success" onClick={startGame}>
              Start Quiz
            </button>
          </div>
        )}

        {gameActive && (
          <div className="quiz-area">
            <div className="question-display">
              {question.num1} {question.operation} {question.num2} = ?
            </div>
            
            <div className="answer-area">
              <input
                type="number"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Your answer"
                className="answer-input"
                autoFocus
              />
              <button 
                className="btn btn-primary"
                onClick={submitAnswer}
                disabled={!userAnswer}
              >
                Submit
              </button>
            </div>
            
            {feedback && (
              <div className={`feedback ${feedback.includes('✅') ? 'correct' : 'incorrect'}`}>
                {feedback}
              </div>
            )}
          </div>
        )}

        {gameOver && (
          <div className="game-over">
            <h2>🎉 Time's Up!</h2>
            <div className="final-score">
              <p>Final Score: {score} out of {questionsAnswered}</p>
              <p>Accuracy: {accuracy}%</p>
              <p>
                {accuracy >= 90 ? '🏆 Excellent!' : 
                 accuracy >= 70 ? '👍 Good job!' : 
                 accuracy >= 50 ? '👌 Not bad!' : '💪 Keep practicing!'}
              </p>
            </div>
          </div>
        )}

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {gameOver ? 'Play Again' : 'New Game'}
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MathQuiz;